import { render, staticRenderFns } from "./pandianItem.vue?vue&type=template&id=754ecc6b&scoped=true&"
import script from "./pandianItem.vue?vue&type=script&lang=js&"
export * from "./pandianItem.vue?vue&type=script&lang=js&"
import style0 from "./pandianItem.vue?vue&type=style&index=0&id=754ecc6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754ecc6b",
  null
  
)

export default component.exports